import lazyLoad from './../utils/lazy'

//const triggers = document.querySelectorAll('.js-menu-trigger')

const cMenuInit = () => {

  const menuButtons = document.querySelectorAll('.js-menu-btn')

  menuButtons.forEach(menuButton => {
    menuButton.addEventListener('click', function (e) {
      document.documentElement.classList.toggle('c-menu-is-open')
      lazyLoad()
    })
  })
  // triggers.forEach(trigger => {
  //   trigger.addEventListener('click', function (e) {
  //     if (trigger.parentElement.classList.contains('is-active')) {
  //       trigger.parentElement.classList.remove('is-active')
  //     } else {
  //       removeActive()
  //       trigger.parentElement.classList.add("is-active")
  //       lazyLoad()
  //     }
  //   })
  // })
  const accordions = document.querySelectorAll(".js-menu-block");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".js-menu-nav");
    accordion.classList.add("is-active");
    content.style.maxHeight = (content.scrollHeight + 40 ) + "px";
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".js-menu-nav");
    accordion.classList.remove("is-active");
    content.style.maxHeight = null;
  };

  accordions.forEach(accordion => {
    const head = accordion.querySelector(".js-menu-trigger");
    const content = accordion.querySelector(".js-menu-nav");

    //console.log(accordion);

    head.addEventListener('click', function (e) {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);
      }
    });
  });

}

// const removeActive = () => {
//   triggers.forEach(trigger => {
//     trigger.parentElement.classList.remove('is-active')
//   })
// }

export default cMenuInit
